import React from 'react';

import Company from 'components/companies/group/company';

import useStyles from 'isomorphic-style-loader/useStyles';
import classes from './style.module.scss';
import globalStyles from 'styles/main.scss';

export default ({ group }) => {
  useStyles(classes, globalStyles);
  
  return (
    <>
      {
        group.landings.length > 0 &&
          <div className={classes.root}>
            <div className={classes.divider} />
            <h2 className={`${globalStyles.mtb10} ${globalStyles.textCenter}`}>
              { group.letter } 
            </h2>
            <div className={classes.groupContainer}>
              {
                group.landings.map((company, index) =>
                  <div key={index} >
                    <Company company={company}/>
                  </div>
                )
              }
            </div>
          </div>
      }
    </>
  );
}